import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LancamentoFinanceiro } from '../../extrato-movimentacoes.component';
import { MovimentacaoService } from '../../../../../shared/services/apis/financas/movimentacao.service';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';

export interface ModalAlterarCategoriaResult {
  idCategoriaFinanceira: number | null;
}

interface CategoriaOption {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-modal-alterar-categoria',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SelectPesquisavelComponent,
  ],
  templateUrl: './modal-alterar-categoria.component.html',
  styleUrls: ['./modal-alterar-categoria.component.css'],
})
export class ModalAlterarCategoriaComponent implements OnInit {
  public isLoading: boolean = false;
  public categoriaOptions: CategoriaOption[] = [];
  public categoriaCtrl = new FormControl<number | null>(null);

  constructor(
    public dialogRef: MatDialogRef<ModalAlterarCategoriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { lancamentos: LancamentoFinanceiro[] },
    private movimentacaoService: MovimentacaoService
  ) {}

  ngOnInit(): void {
    this.carregarCategorias();
  }

  private carregarCategorias(): void {
    this.isLoading = true;
    this.movimentacaoService.getLookup().subscribe({
      next: response => {
        this.isLoading = false;
        if (!response.isError) {
          this.categoriaOptions = (response.listaCategoriasFinanceira || [])
            .filter(c => c.isAtivo)
            .map(c => ({ id: c.idCategoriaFinanceira, descricao: c.descricao }));
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  public salvar(): void {
    const result: ModalAlterarCategoriaResult = {
      idCategoriaFinanceira: this.categoriaCtrl.value ?? null,
    };
    this.dialogRef.close(result);
  }
}
